/**
 * Location fixtures for Austria.
 * Used across jobs, resume, and organizations configs.
 */

const locationFixtures = [
  { label: 'Linz, Österreich', location: { lat: 48.3069, lng: 14.2858 } },
  { label: 'Wien, Österreich', location: { lat: 48.2082, lng: 16.3738 } },
  { label: 'Graz, Österreich', location: { lat: 47.0707, lng: 15.4395 } },
  { label: 'Braunau am Inn, Österreich', location: { lat: 48.2595, lng: 13.0353 } },
  { label: 'Haag, Österreich', location: { lat: 48.1102, lng: 14.5699 } },
  { label: 'Oberösterreich, Österreich', location: { lat: 48.0233, lng: 13.9853 } },
];

module.exports = { locationFixtures };
